import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import UserRole from '../../shared/model/UserRole';

export default class UsersManagersRequest extends GenericRequest {

    constructor() {
        super(METHOD_POST, ApiEndpoints.USERS);
    }

    overrideRequest() {
        const request = {};
        request.criteria = {
            role_ids: [UserRole.OUTSOURCES_MANAGER],
            skip_pagination: true,
        };
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/users/ws/UsersManagersRequest.js